import React, { useRef, useEffect } from 'react'
import DynamicForm from '@/components/DynamicForm'
import formView from './shapeProfileForm'
import { Button } from '@/components/UiElements'

import calculateHeightWithLid from './utils/calculateHeightWithLid'
import calculateHeight from './utils/calculateHeight'

const ShapeProfile = ({ item, bound, close, submit, data, bind }) => {
  const formRef = useRef(null)

  const saveData = async () => {
    const data = await formRef?.current?.getData()
    if (data) {
      submit(data)
      close()
    }
  }

  const [glbHeight, setGlbHeight] = React.useState(null)
  useEffect(() => {
    const fetchHeight = async () => {
      const val = await calculateHeightWithLid(item?.defaultValue?.glb)
      bind(val)
      setGlbHeight(val?.y)
    }

    // Call the async function
    fetchHeight()
  }, [item?.defaultValue?.glb])

  return (
    <div className={'py-xl px-xl grid grid-cols-12 gap-md'}>
      {glbHeight && (
        <DynamicForm
          ref={formRef}
          items={formView}
          defaultValues={{
            ...item?.defaultValue,
            ...data?.[item?.name],
            stl: calculateHeight(item?.defaultValue?.stl),
            glb: parseFloat(glbHeight / 2).toFixed(2),
          }}
          //defaultValues={item.defaultValues || {}}
          size={'md'}
        />
      )}
      <div className={'pt-md flex flex-row gap-sm justify-end col-span-12'}>
        <Button
          className={' !flex-row flex'}
          type={'alt'}
          onClick={() => {
            close()
          }}
        >
          <div className={'flex flex-row gap-md'}>Cancel</div>
        </Button>
        <Button
          className={' !flex-row flex'}
          onClick={() => {
            saveData()
          }}
        >
          <div className={'flex flex-row gap-md'}>Create Shape Profile</div>
        </Button>
      </div>
    </div>
  )
}

export default ShapeProfile

const OpenShapeProfileForm = ({ value, onChange, show, data, defaultValues }) => {
  return (
    <div className={'flex flex-row gap-md'}>
      {data?.shape_profile.shape_profile_name || defaultValues ? (
        <Button
          type={'alt'}
          className={' !flex-row flex'}
          onClick={() => {
            show()
          }}
        >
          <div className={'flex flex-row gap-md'}>
            <span className={'font-icon-solid'}></span>
            Edit &quot;{data?.shape_profile?.shape_profile_name || defaultValues?.shape_profile_name}&quot;
          </div>
        </Button>
      ) : (
        <Button
          type={'primary'}
          className={' !flex-row flex'}
          onClick={() => {
            show()
          }}
        >
          <div className={'flex flex-row gap-md'}>
            <span className={'font-icon-solid'}>+</span>
            Shape Profile
          </div>
        </Button>
      )}
    </div>
  )
}
export { OpenShapeProfileForm }
